import { render, staticRenderFns } from "./toAllocated.vue?vue&type=template&id=a8e60692&scoped=true&"
import script from "./toAllocated.vue?vue&type=script&lang=js&"
export * from "./toAllocated.vue?vue&type=script&lang=js&"
import style0 from "./toAllocated.vue?vue&type=style&index=0&id=a8e60692&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e60692",
  null
  
)

export default component.exports